export const EXPORTATION_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": [
    "Organization",
    "Corporation"
   ],
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": "https://everest.ind.br/logo.png",
   "image": "https://everest.ind.br/logo.png",
   "sameAs": [
    "https://pt.wikipedia.org/wiki/Everest_(empresa)",
    "https://www.instagram.com/everestoficial_",
    "https://www.linkedin.com/company/everestoficial/"
   ],
   "areaServed": [
    {
     "@type": "Place",
     "name": "South America"
    },
    {
     "@type": "Place",
     "name": "International"
    }
   ]
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR"
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/exportacao#webpage",
   "url": "https://everest.ind.br/pt/exportacao",
   "name": "Exportação | Everest",
   "description": "A Everest exporta purificadores de água e máquinas de gelo para mercados internacionais, sendo líder sul-americano no segmento.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "primaryImageOfPage": "https://everest.ind.br/images/exportacao.jpg",
   "dateModified": "2026-04-15",
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/exportacao#breadcrumb"
   },
   "mainEntity": {
    "@type": "Organization",
    "name": "Exportação Everest",
    "description": "Divisão responsável pela exportação de purificadores de água e máquinas de gelo para mercados internacionais.",
    "areaServed": "Worldwide"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/exportacao#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Exportação",
     "item": "https://everest.ind.br/pt/exportacao"
    }
   ]
  }
 ]
}
